import AppInfoFooter from "../../../components/AppInfoFooter";
import Page from "../../../components/Page";

const ResendInvitationSuccessPage = () => (
  <Page className="bg-gray-50">
    <div className="flex h-full flex-col justify-between">
      <div className="mx-auto mt-10 flex w-full max-w-[480px] flex-col items-center rounded-xl bg-white p-12 shadow-2xl">
        <h2 className="mb-8 text-center text-4xl text-primary/90">
          Invitation mail sent successfully
        </h2>
        <p className="material-icons-outlined mb-8 text-green-600" style={{ fontSize: "100px" }}>
          check_circle
        </p>
        <p className="mb-8 text-pretty text-center text-primary/90">
          A new invitation email was successfully sent.
          <br />
          Please check your inbox.
        </p>
      </div>
      <AppInfoFooter className="mt-auto p-4" />
    </div>
  </Page>
);

export default ResendInvitationSuccessPage;
